
import { createApiClient } from 'Network/ApiClient';
  
  export const PatientActivityManagementAxiosInstance = createApiClient('activitypatient/');


